import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numeroSinCod'
})
export class NumeroSinCodPipe implements PipeTransform {

  transform(numero: any, texto: string): any[] {
    if(!texto){
      return numero;
    }

    if(numero.startsWith('521')){
      // let data = numero.split('521')
      // numero = data[1]
      console.log('se cumple condicion');
      return numero = numero.substring(3,13)
        } else {
          return numero
        }
  }

}